(function () {
    'use strict';

    angular.module("imApp").factory("undoDeliveryOnOrderService", ['$ihttp', function ($ihttp) {
        let service = {
            getUndoDeliveryOnOrder: function (parms) {
                return $ihttp.post({
                    method: 2365,
                    parameters: parms || {}
                });
            },
            fetchOrderOrderNo: function (parms) {
                return $ihttp.post({
                    method: 2366,
                    parameters: parms
                });
            },
            undoDelivery: function (parms) {
                return $ihttp.post({
                    method: 2367,
                    parameters: parms
                });
            },
            getUndoOrderDeliveryGrid: function (parms) {
                return $ihttp.post({
                    method: 2368,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
